<template>
  <div class="regulations-page">
    <div class="container">
      <Toolbar title-tag="h1">
        <template #title>
          Регламент
        </template>
      </Toolbar>

      <!-- <ContentBlock class="pt-4">
        <RegulationsSoon />
      </ContentBlock> -->
      <ContentBlock class="regulations-page__body">
        <div class="regulations-page__texts">
          <h2>Документы</h2>
        </div>
        <div class="regulations-page__actions">
          <AppBtn
            href="/uploads/ОФИЦИАЛЬНОЕ_ПОЛОЖЕНИЕ_Red_Bull_Шик_2022_от_02_февраля.pdf"
            target="_blank"
            class="regulations-page__btn"
            color="third"
          >
            Регламент
          </AppBtn>
        </div>
      </ContentBlock>
      <!-- <ContentBlock class="regulations-page__body">
        <div class="regulations-page__texts">
          <h2>Документы</h2>
        </div>
        <div class="regulations-page__actions">
          <AppBtn
            href="/uploads/Положение_отборочных_соревнований.pdf"
            target="_blank"
            class="regulations-page__btn"
            color="third"
          >
            Регламент
          </AppBtn>
          <AppBtn
            href="/uploads/Положение_финальных_соревнований.pdf"
            target="_blank"
            class="regulations-page__btn"
            color="third"
          >
            Регламент нац. финала
          </AppBtn>
        </div>
      </ContentBlock> -->
    </div>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar/";

export default {
  name: "RegulationsPage",
  components: {
    Toolbar
  },
  breadcrumb: {
    title: "Регламент",
    to: "/regulations"
  }
};
</script>

<style lang="scss">
.regulations-page {
  padding-bottom: 200px;

  &__texts {
    font-size: 18px;
    color: colors(text-2);
    line-height: 1.7;
    padding: 30px 40px;

    p {
      margin-bottom: 45px;
    }

    h2,
    h3,
    h4,
    h5,
    h6 {
      color: colors(text-2);
      margin-bottom: 1.5em;
    }
  }

  &__body {
    padding: 15px 15px 50px;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  &__btn {
    text-transform: uppercase;
    height: 55px;
    width: 450px;
    max-width: 100%;
    font-size: 18px;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  @include breakpoint("sm-and-down") {
    &__btn {
      font-size: 14px;
    }
    p {
      margin-bottom: 25px;
    }
  }
}
</style>
